import { render, staticRenderFns } from "./time-MT5.vue?vue&type=template&id=7ac338a7&scoped=true&"
import script from "./time-MT5.vue?vue&type=script&lang=js&"
export * from "./time-MT5.vue?vue&type=script&lang=js&"
import style0 from "./time-MT5.vue?vue&type=style&index=0&id=7ac338a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac338a7",
  null
  
)

export default component.exports